module.exports = __webpack_public_path__ + "img/icon-check-circle.c0e107d3.svg";